import React from "react"
import { useTranslation } from "react-i18next"
import "./style/AccountTypes.scss"

type FeatureKey =
  | "access"
  | "email"
  | "academy"
  | "riskFree"
  | "welcomeCall"
  | "sessions"
  | "inbounds"
  | "withdrawals"
  | "firstToKnow"
  | "maxTrade"
  | "guide"

type Features = Record<FeatureKey, boolean | string>

type Account = {
  name: string
  features: Features
}

const accountData: Account[] = [
  {
    name: "Beginner",
    features: {
      access: true,
      email: true,
      academy: true,
      riskFree: "1",
      welcomeCall: true,
      sessions: "1 call/week",
      inbounds: false,
      withdrawals: "Slow",
      firstToKnow: false,
      maxTrade: "€250",
      guide: false
    }
  },
  {
    name: "Silver",
    features: {
      access: true,
      email: true,
      academy: true,
      riskFree: "2",
      welcomeCall: true,
      sessions: "3 calls/week",
      inbounds: false,
      withdrawals: "Normal",
      firstToKnow: false,
      maxTrade: "€1000",
      guide: true
    }
  },
  {
    name: "Gold",
    features: {
      access: true,
      email: true,
      academy: true,
      riskFree: "4",
      welcomeCall: true,
      sessions: "5 calls/week",
      inbounds: false,
      withdrawals: "Faster",
      firstToKnow: true,
      maxTrade: "€2500",
      guide: true
    }
  },
  {
    name: "Platinum",
    features: {
      access: true,
      email: true,
      academy: true,
      riskFree: "10",
      welcomeCall: true,
      sessions: "Personal Manager",
      inbounds: true,
      withdrawals: "Same day",
      firstToKnow: true,
      maxTrade: "€10000",
      guide: true
    }
  }
]

const featureKeys: FeatureKey[] = [
  "access",
  "email",
  "academy",
  "riskFree",
  "welcomeCall",
  "sessions",
  "inbounds",
  "withdrawals",
  "firstToKnow",
  "maxTrade",
  "guide"
]

const AccountTypes: React.FC = () => {
  const { t } = useTranslation()

  return (
    <section className="account-types">
      <h2>{t("accountTypes.title")}</h2>

      <div className="account-table">
        <div className="table-header">
          <div className="feature-col" />
          {accountData.map((acc) => (
            <div key={acc.name} className="account-col">
              <h3>
                {t(`accountTypes.accounts.${acc.name}.label`, acc.name)}
              </h3>
              <p className="price">
                {t(`accountTypes.accounts.${acc.name}.price`, "")}
              </p>
            </div>
          ))}
        </div>

        {featureKeys.map((key) => (
          <div key={key} className="table-row">
            <div className="feature-col">
              {t(`accountTypes.features.${key}`)}
            </div>
            {accountData.map((acc) => {
              const value = acc.features[key]
              return (
                <div key={`${acc.name}-${key}`} className="account-col">
                  {typeof value === "boolean" ? (
                    value ? "✔️" : "❌"
                  ) : (
                    value
                  )}
                </div>
              )
            })}
          </div>
        ))}
      </div>
    </section>
  )
}

export default AccountTypes
